'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _require = require('react'),
    useRef = _require.useRef,
    useState = _require.useState,
    useEffect = _require.useEffect;

require('intersection-observer');

/**
 * Visibility hook for functional components
 *
 * @export
 * @param {DOMNode reference} node
 * @param {Object} [options={}]
 * @returns {object} visibility
 */
function useVisibility(node) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisibilty = _useState2[1];

  var isIntersecting = useRef();

  var handleObserverUpdate = function handleObserverUpdate(entries) {
    var ent = entries[0];

    if (isIntersecting.current !== ent.isIntersecting) {
      setVisibilty(ent);
      isIntersecting.current = ent.isIntersecting;
    }
  };

  var observer = new IntersectionObserver(handleObserverUpdate, options);

  useEffect(function () {
    var element = node.current;

    if (!element) {
      return;
    }

    observer.observe(element);

    return function cleanup() {
      observer.unobserve(element);
    };
  });

  return visible;
}

module.exports = useVisibility;